import SVG from './image.svg';
import { face } from '~/notations';

export default {
  SVG,
  algorithm: [
    face.m.two,
    face.u.pri,
    [
      face.m.pri,
      face.u.pri,
      face.m.pri,
    ],
  ],
  name: '2T & 2B [Adjacent]',
};
